import { memo, useMemo } from "react";

import { useInitialized } from "../../../model/tl-lincoln/use-case";
import { SettingsSiteControllerHeader, ReferenceArticles } from "../_shared";
import { REFERENCE_ARTICLES } from "./constants";
import { useSettingsSiteControllerTlLincoln } from "./hooks";
import { SettingsSiteControllerTLLincolnMainIsland } from "./island/main";

import type { SiteControllerSettingBaseFormModel } from "../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../model/base/use-case/use-create-model/methods";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../model/base/use-case/use-create-model/use-create-model";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
	resetViewModel: () => void;
	siteControllerSettingBaseFormModelMethodsType: SiteControllerSettingBaseFormModelMethodsType;

	queryData: SiteControllerSettingBaseFormModel["QueryData"];
};

export const SettingsSiteControllerTLLincoln = memo(
	({
		viewModel: baseViewModel,
		onSetViewModel, //
		resetViewModel,
		siteControllerSettingBaseFormModelMethodsType,
		queryData,
	}: Props) => {
		const { tlLincolnViewModel, siteControllerSettingTLLFormModelMethods } = useInitialized({
			viewModel: baseViewModel,
			onSetViewModel,
		});

		const { onUpdate } = useSettingsSiteControllerTlLincoln({
			viewModel: tlLincolnViewModel,
			onResetViewModel: resetViewModel,
		});

		const isValid = useMemo(
			() => baseViewModel.isDirty && !baseViewModel.hasError,
			[baseViewModel.hasError, baseViewModel.isDirty],
		);

		return (
			<>
				<SettingsSiteControllerHeader onUpdate={onUpdate} isValid={isValid} />

				<ReferenceArticles articles={REFERENCE_ARTICLES} />

				<SettingsSiteControllerTLLincolnMainIsland
					hotelID={baseViewModel.hotelID}
					baseViewModel={baseViewModel}
					siteControllerSettingBaseFormModelMethodsType={siteControllerSettingBaseFormModelMethodsType}
					tlLincolnViewModel={tlLincolnViewModel}
					siteControllerSettingTLLincolnFormModelMethods={{ siteControllerSettingTLLFormModelMethods }}
					queryData={queryData}
				/>
			</>
		);
	},
);

SettingsSiteControllerTLLincoln.displayName = "SettingsSiteControllerTLLincoln";
